import { RouteConfig } from "vue-router";

const condicionesDivisiones: RouteConfig = {
  path: "/condicionesDivisiones",
  name: "condicionesDivisiones",
  component: () => import(/* webpackChunkName: "condiciones-divisiones" */ "@/views/CondicionesDivisiones.vue"),
};

export default condicionesDivisiones;